module.exports = __webpack_public_path__ + "static/media/TECHJAM2017-2018.a30e4eb4.png";